module.exports = __webpack_public_path__ + "h5/img/ywc001.ebcd95bf.gif";